export default [
    {
        name: "Astronomers default set",
        columns: [
            "neighbors.objid",
            "neighbors.neighborobjid",
            "neighbors.distance",
            "neighbors.type",
            "neighbors.neighbortype",
            "photoobj.objid",
            "photoobj.run",
            "photoobj.rerun",
            "photoobj.camcol",
            "photoobj.field",
            "photoobj.mode",
            "photoobj.type",
            "photoobj.clean",
            "photoobj.flags",
            "photoobj.rowc",
            "photoobj.colc",
            "photoobj.rowv",
            "photoobj.colv",
            "photoobj.psfmag_u",
            "photoobj.psfmag_g",
            "photoobj.psfmag_r",
            "photoobj.psfmag_i",
            "photoobj.psfmag_z",
            "photoobj.psfmagerr_u",
            "photoobj.psfmagerr_g",
            "photoobj.psfmagerr_r",
            "photoobj.psfmagerr_i",
            "photoobj.psfmagerr_z",
            "photoobj.fibermag_u",
            "photoobj.fibermag_g",
            "photoobj.fibermag_r",
            "photoobj.fibermag_i",
            "photoobj.fibermag_z",
            "photoobj.petromag_u",
            "photoobj.petromag_g",
            "photoobj.petromag_r",
            "photoobj.petromag_i",
            "photoobj.petromag_z",
            "photoobj.petrorad_u",
            "photoobj.petrorad_g",
            "photoobj.petrorad_r",
            "photoobj.petrorad_i",
            "photoobj.petrorad_z",
            "photoobj.devmag_u",
            "photoobj.devmag_g",
            "photoobj.devmag_r",
            "photoobj.devmag_i",
            "photoobj.devmag_z",
            "photoobj.expmag_u",
            "photoobj.expmag_g",
            "photoobj.expmag_r",
            "photoobj.expmag_i",
            "photoobj.expmag_z",
            "photoobj.expmagerr_u",
            "photoobj.expmagerr_g",
            "photoobj.expmagerr_r",
            "photoobj.expmagerr_i",
            "photoobj.expmagerr_z",
            "photoobj.modelmag_u",
            "photoobj.modelmag_g",
            "photoobj.modelmag_r",
            "photoobj.modelmag_i",
            "photoobj.modelmag_z",
            "photoobj.modelmagerr_u",
            "photoobj.modelmagerr_g",
            "photoobj.modelmagerr_r",
            "photoobj.modelmagerr_i",
            "photoobj.modelmagerr_z",
            "photoobj.cmodelmag_u",
            "photoobj.cmodelmag_g",
            "photoobj.cmodelmag_r",
            "photoobj.cmodelmag_i",
            "photoobj.cmodelmag_z",
            "photoobj.cmodelmagerr_u",
            "photoobj.cmodelmagerr_g",
            "photoobj.cmodelmagerr_r",
            "photoobj.cmodelmagerr_i",
            "photoobj.cmodelmagerr_z",
            "photoobj.ra",
            "photoobj.dec",
            "photoobj.raerr",
            "photoobj.b",
            "photoobj.l",
            "photoobj.extinction_r",
            "photoobj.extinction_i",
            "photoobj.mjd",
            "photoobj.loadversion",
            "photoobj.u",
            "photoobj.g",
            "photoobj.r",
            "photoobj.i",
            "photoobj.z",
            "photoobj.dered_u",
            "photoobj.dered_g",
            "photoobj.dered_r",
            "photoobj.dered_i",
            "photoobj.dered_z",
            "photoobj.tai_u",
            "photoobj.tai_g",
            "photoobj.tai_r",
            "photoobj.tai_i",
            "photoobj.tai_z",
            "galspecline.specobjid",
            "spplines.specobjid",
            "specobj.specobjid",
            "specobj.bestobjid",
            "specobj.plateid",
            "specobj.scienceprimary",
            "specobj.segue2primary",
            "specobj.survey",
            "specobj.programname",
            "specobj.mjd",
            "specobj.plate",
            "specobj.fiberid",
            "specobj.segue2_target1",
            "specobj.segue2_target2",
            "specobj.ra",
            "specobj.dec",
            "specobj.z",
            "specobj.zerr",
            "specobj.zwarning",
            "specobj.class",
            "specobj.subclass",
            "specobj.veldisp",
            "specobj.veldisperr",
            "specobj.loadversion",
            "specobj.special_target1",
            "specobj.ancillary_target1",
            "specobj.petroR90_r",
        ],
    },
] as { name: string; columns: string[] }[];
